import React, { PropTypes } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { PrimaryButton } from '@bibliocommons/base-buttons';
import { CloudDownload, RightArrowCircledOutline, ExternalArrow, Info } from '@bibliocommons/base-icons';

import './CheckedOutReadingLinks.scss';

export class CheckedOutReadingLinks extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('handleCheckIn', 'startDigitalMissingFormatSelection');
  }

  handleCheckIn(e) {
    e.preventDefault();
    const { accountId, metadataId, checkoutId, messagingId } = this.props;
    this.props.checkIn({ accountId, metadataId, messagingId, checkoutId });
  }

  startDigitalMissingFormatSelection(e) {
    e.preventDefault();
    this.props.startDigitalMissingFormatSelection(this.props.metadataId);
  }

  renderThirdPartyReaderLink() {
    if (this.props.thirdPartyReaderUrl) {
      return (
        <a
          href={this.props.thirdPartyReaderUrl}
          rel="noopener noreferrer"
          target="_blank"
          className="btn btn-link"
          data-testid="link_thirdparty_reader">
          <RightArrowCircledOutline />
          <div>
            <FormattedMessage id="open_in_third_party_reader" />
            <ExternalArrow />
          </div>
        </a>
      );
    }

    return null;
  }

  renderCheckInLink() {
    if (this.props.checkInEnabled) {
      return (
        <PrimaryButton
          block
          handleClick={this.handleCheckIn}
          disabled={this.props.disabled}>
          <FormattedMessage id="digital_return_now" />
        </PrimaryButton>
      );
    }

    return null;
  }

  renderDownloadBlock() {
    if (this.props.policy.get('supportsDownload')) {
      if (!this.props.downloadable && this.props.thirdPartyReaderUrl) {
        // The service supports downloading but the format isn't downloadable (e.g MediaDo)
        return null;
      }

      if (this.props.format) {
        if (this.props.downloadUrl) {
          return (
            <a
              href={this.props.downloadUrl}
              className="btn btn-link"
              target="_blank"
              rel="noopener noreferrer">
              <CloudDownload />
              <FormattedMessage
                id={`download_now_${this.props.format.toLowerCase()}`}
                defaultMessage={
                  this.props.intl.formatMessage({
                    id: 'download_now_format'
                  }, {
                    format: this.props.intl.formatMessage({ id: `digiformat_${this.props.format.toLowerCase()}` })
                  })
                } />
            </a>
          );
        }

        return (
          <a href={this.props.policy.get('helpUrl')} target="_blank" rel="noopener noreferrer" className="btn btn-link">
            <Info />
            <div>
              <FormattedMessage id="how_do_i_get_digital_checkout">
                {(message) => <span aria-hidden>{message}</span>}
              </FormattedMessage>
              <ScreenReaderMessage><FormattedMessage id="ada_how_do_i_get_digital_checkout" /></ScreenReaderMessage>
              <ExternalArrow />
            </div>
          </a>
        );
      }

      return (
        <button
          disabled={this.props.disabled}
          onClick={this.startDigitalMissingFormatSelection}
          className="btn btn-link download-missing-format">
          <CloudDownload />
          <FormattedMessage id="missing_format_download" />
        </button>
      );
    }
    return (
      // Get Link URL from Settings
      <a href={this.props.policy.get('quickStartUrl')} target="_blank" rel="noopener noreferrer" className="btn btn-link">
        <Info />
        <div>
          <FormattedMessage id="how_do_i_3m">
            {(message) => <span aria-hidden>{message}</span>}
          </FormattedMessage>
          <FormattedMessage id="ada_how_do_i_3m">
            {(message) => <ScreenReaderMessage>{message}</ScreenReaderMessage>}
          </FormattedMessage>
          <ExternalArrow />
        </div>
      </a>
    );
  }

  render() {
    const { policy } = this.props;
    return (
      <div className="cp-checked-out-reading-links">
        {this.renderCheckInLink()}

        <div className="access-title-block">
          {policy.get('supportsDownload') && <FormattedMessage tagName="h3" id="access_this_title" />}
          {this.renderDownloadBlock()}
          {this.renderThirdPartyReaderLink()}
        </div>
      </div>
    );
  }
}

CheckedOutReadingLinks.propTypes = {
  checkInEnabled: PropTypes.bool,
  disabled: PropTypes.bool,
  policy: PropTypes.shape({
    thirdPartyReaderUrl: PropTypes.string,
    supportsDownload: PropTypes.bool,
    quickstartUrl: PropTypes.string,
    helpUrl: PropTypes.string
  }),
  checkoutId: PropTypes.string.isRequired,
  metadataId: PropTypes.string.isRequired,
  accountId: PropTypes.number.isRequired,
  downloadable: PropTypes.bool,
  downloadUrl: PropTypes.string,
  format: PropTypes.string,
  checkIn: PropTypes.func.isRequired,
  startDigitalMissingFormatSelection: PropTypes.func.isRequired,
  messagingId: PropTypes.string
};

export default injectIntl(CheckedOutReadingLinks);



// WEBPACK FOOTER //
// ./app/components/shared/ItemTransactions/components/checked-out-reading-links/components/CheckedOutReadingLinks.component.jsx